export default __webpack_public_path__ + "static/media/search.b1b503cf.svg";